<template>

	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-show="pop_show"  >
		<span class="pop_bg" @click="closeshow()"></span>

		<div id="pop_bodyup" class="pop_content">
			<!-- 动态查询区生成 -->
			<div class="pop_head_close">
				<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
			</div>
			<div>
				<h5>{{title}}&nbsp;&nbsp;</h5>
				<span class="red">操作说明:直接填写转出数量后预生成明细，点击保存完成更新!每个仓库同一时间有且只能有个处于编辑中。</span>
				<span class="red">必须提交转移单才能减少数量。</span>
			</div>

			<div class="content_edit">
				<div class="content_edit_item">
					<button class="pre_btn_ok" @click="refresh_data()">
						刷新
					</button>
					<button class="pre_btn_ok" @click="fun_upd('_add')">
						生成转移单
					</button>
					<button class="pre_btn_ok" @click="fun_upd('_addall')">
						全部回仓
					</button>
					<label>单号:{{sheet_no}}</label><label class="red">&nbsp;&nbsp;{{sheet_flag}}</label>
				</div>
			</div>
			<div class="inline-row">
				<div class="content_edit_item">
					<label>出仓:{{from_name}}</label>
				</div>
				<div class="content_edit_item" v-for="(item,index) in parm" :key="index">

					<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_all">
					</component>

				</div>
				<!-- <div class="content_edit_item" >
						<label >备注:</label>
						<input type="text" class="long1" v-model="note"  />
						<em>*</em>
					</div> -->
			</div>
			<div class="inline-row-tab" v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="inline-tab">
					<table class="dataintable mark_tab">
						<tr class="tab_header">
							<td>ID</td>
							<td>序号</td>
							<td>仓库</td>
							<td>物品名称</td>
							<td>批次价格</td>
							<td>拥有数量</td>
							<td>待出数量</td>
							<!-- <td class="short0 cen">编辑</td> -->
						</tr>
						<tr :id="'pop_m_'+item.row_num" v-for="(item,index) in list_from" :key="index">
							<td>{{item.id}}</td>
							<td>{{item.row_num}}</td>
							<td>{{item.name}}</td>
							<td>{{item.item_name}}</td>
							<td>{{item.pi_price}}</td>
							<td>{{item.qty}}</td>
							<td>
								<input type="number" style="width: 120px;" v-model="item.out_qty"
									@keyup.enter="sel_row(item,'add')" />
							</td>
							<!-- <td class="short0 cen">
								<button @click="sel_row(item,'add')">保存</button>
								<button @click="sel_row(item,'del')">删除</button>
							</td> -->
						</tr>
					</table>
				</div>
				<div class="inline-tab">
					<table class="dataintable mark_tab">
						<tr class="tab_header">
							<td>ID</td>
							<td>序号</td>
							<td>物品名称</td>
							<td>单价</td>
							<td>数量</td>
							<td>修改人</td>
							<td>更新时间</td>
							<td class="short0 cen">编辑</td>
						</tr>
						<tr :id="'pop_md_'+item.row_num" v-for="(item,index) in list_from_detail" :key="index"
							@click="sel_row_d(item,'edit')">
							<td>{{item.id}}</td>
							<td>{{item.row_num}}</td>
							<td>{{item.item_name}}</td>
							<td>{{item.price}}</td>
							<td>{{item.qty}}</td>
							<!-- <td><input type="text" style="width: 120px;" v-model="item.name" @keyup.enter="sel_row(item,'add')" />
              </td> -->
							<td>{{item.u_name}}</td>
							<td>{{item.sys_date}}</td>
							<td class="short0 cen">
								<button @click="fun_upd_item('_del',item)">删除</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>



	</div>
	<!-- 弹出向导层 end-->


</template>

<script>
	/*
名称：等级划分
日期：2022-03-19
作者：hj
目标：
方法 传入参数，
1、查询标识
2、编辑标识
*/

	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_Common,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';
	
	import {
		dateFormatbyChina,
		dateFormatToChina,
		Word_Right_Delete,
		ReplaceAll
	} from '@/utils/method.js';

	export default {
		name: "pre_mark_tan",
		components: {
			"pre-table": () => import("../auto/auto_view_table.vue")
		},
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				load_url: '',
				load_json: '',
				upd_json: '',
				screenWidth: '',
				screenHeight: '',

				title: '转移单预制',
				sheet_no: '',
				sheet_flag: '',
				sel_action: '',
				upd_action: '',
				row_id: '',
				sel_item: [], //备份点击项目
				sys_date: '',

				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',

				max_row: [],

				list_from: [],
				list_from_detail: [],
				from_name: '',
				sys_val: 0,
				note: '',
				
				item_id: 0,
				item_name: '',

				// post_select: ''
				tid: 0,
				tsysdate: '',
				d_parm: [], //参数结构
				

			};
		},
		methods: {
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			NextTickName: function(key) {
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_all: function(d, type) {
				// console.log(d);
				
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}

			},
			load_data: function(res) {

				this.from_name = res;
				console.log('出库=' + res);

				this.parm = [{
						"name": "入库名称",
						"val": "",
						"key": "in_store",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_store",
						"sel_name": "",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "出库日期",
						"val": "",
						"key": "out_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long1",
						"p": "1",
						"w": "0",
						"r": "0",
						"x": "1"
					}
				]



				this.refresh_data();

			},
			refresh_data: function() {
				// console.log('刷新sheet_no='+this.sheet_no);
				this.row_id = '';
				this.sys_date = '';

				this.element_loading = true;

				// 根据 出仓名称判断当前 是否存在修改中转移单，有则加载.无则新建

				this.$post(
					api.http_method, Sel_page_and_length('exp_store_car_is_build_from', 1, 100, this.from_name)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);

					// console.log(res);
					if (res[0][0].flag == '1') {
						// console.log(res[1][0]);

						for (let d in res[1][0]) {
							// console.log(d + ' = ' + res[1][0][d]);
							switch (d) {
								case 'id':
									this.row_id = res[1][0][d];
									break;
								case 'flag':
									this.sheet_flag = res[1][0][d];
									break;
								case 'sys_date':
									this.sys_date = res[1][0][d];
									break;
								case 'sheet_no':
									this.sheet_no = res[1][0][d];
									break;
								default:
									break;
							}

			
							for (let j = 0; j < this.parm.length; j++) {
								if (this.parm[j].key == d) {
									if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
										// console.log(this.parm[j]);
										this.parm[j].val = '';
										this.parm[j].sel_name = res[1][0][d];
									} else {
										this.parm[j].val = res[1][0][d];
									}

								}
							}
						}

						if (res.length > 2) {
							// console.log('可转范围',res[2]);
							this.list_from = res[2];
						}
						// console.log('主参', this.parm);
						
						this.refresh_item(); //加载当前预转出的明细

					} else {
						this.$message({
							message: res[0][0].err,
							type: 'warning'
						});
					}

					// let o = {};
					// o.id = 0;
					// o.row_num = this.list_from.length + 1;
					// o.name = '';
					// o.u_name = '';
					// o.sys_date = '';
					// this.list_from.push(o);
				});
				// this.change_style();
			},
			sel_row: function(item, type) {
				// console.log(item, 'type=' + type);
				// console.log(this.parm);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
								
				if(Number(item.out_qty)<0){
					this.$message({
						message: '转出数量必须大于0',
						type: 'warning'
					});
				}
				
				if(Number(item.out_qty)>Number(item.qty)){
					this.$message({
						message: '转出数量'+item.out_qty+'大于 现有数量'+item.qty+' 请刷新重试!',
						type: 'warning'
					});
				}
				
				switch (type) {
					case 'edit': // 切换背景色
						let key = 'pop_m_';

						for (var i = 0; i < this.list_from.length; i++) {
							if (this.list_from[i].row_num == item.row_num) {
								document.getElementById(key + item.row_num).style.background = '#92a4f3';
							} else {
								if (this.list_from[i].row_num % 2 == 0) {
									document.getElementById(key + this.list_from[i].row_num).style.background =
										'#fff';
								} else {
									document.getElementById(key + this.list_from[i].row_num).style.background =
										'#f5f5f5';
								}
							}
						}
						break;
						// case 'show': // 打开编辑页面
						// 	this.$refs.file_table.showpop();
						// 	break;
					case 'add': // 执行保存
						this.fun_upd_item('_add',item);
						break;
					// case 'del': // 执行保存
					// 	this.fun_upd('_del');
					// 	break;
					default:
						break;
				}
			},
			fun_upd:async function(type) {
				// console.log('操作类型=' + type);
				
				// 自检
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {
						let temp = '';
						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							temp = dateFormatbyChina(this.parm[i].val);
						} else if (this.parm[i].type == 'selectnew') {
							console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else {
								temp = '0';
								for (let j = 0; j < this.parm[i].list.length; j++) {
									if (this.parm[i].list[j].val == this.parm[i].sel_name) {
										temp = this.parm[i].list[j].id;
									}
								}
							}
				
						} else if (this.parm[i].type == 'select') {
							// console.log(this.parm[i].key + '下拉选项', this.parm[i])
							if (typeof(this.parm[i].val) === 'number' && Number(this.parm[i].val) > 0) {
								temp = this.parm[i].val;
							} else if (typeof(this.parm[i].list)!=='undefined' && this.parm[i].list.length>0){
								temp = '0';
								let tlist = this.parm[i].list;
								for (let j = 0; j < tlist.length; j++) {
									if (tlist[j].val == this.parm[i].sel_name) {
										temp = tlist[j].id;
									}
								}
							} else {
								temp = '0';
								let t_action = this.parm[i].sel_action;
								let res = await this.loadClass(t_action);
								console.log(res);
								if (res.status == '1') {
									let tlist = res.data;
									for (let j = 0; j < tlist.length; j++) {
										if (tlist[j].val == this.parm[i].sel_name) {
											temp = tlist[j].id;
										}
									}
								}
				
							}
				
						} else {
							temp = this.parm[i].val;
						}
				
						this.parm[i].val = temp;
					}
				}

				let d = [];
				d.push(this.sheet_no);
				d.push(this.from_name);
				for (let j = 0; j < this.parm.length; j++) {
					d.push(this.parm[j].val);
				}
				
				this.element_loading = true;

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('data_store_car_back_m' + type, this.row_id, this.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.refresh_data();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			fun_upd_item: function(type, item) {
				// console.log('操作类型=' + type);
				// console.log('操作明细=' , item);
				
				let d_row_id=0,d_sys_date='',d_note='';
				
				if (this.list_from_detail.length>0){
					for(let i=0;i<this.list_from_detail.length;i++){
						if(this.list_from_detail[i].item_no==item.item_no){
							d_row_id=this.list_from_detail[i].id;
							d_sys_date=this.list_from_detail[i].sys_date;
							d_note=this.list_from_detail[i].note;
							break;
						}
					}
				}

				let d = [];
				d.push(this.sheet_no);
				d.push(item.item_no);
				d.push(item.out_qty);
				d.push(d_note);
				
				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common('data_store_car_d_isBuild_from' + type, d_row_id, d_sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.refresh_item();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			refresh_item: function() {
				this.element_loading = true;
				this.list_from_detail = [];

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Sel_page_and_length('exp_store_car_isBuild_d', 1, 100, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					if (res.length > 0) {
						let t = res[0];
						for (let i = 0; i < t.length; i++) {
							t[i].row_num = i + 1;
							this.list_from_detail.push(t[i]);
						}
						// console.log(this.list_from_detail);
					}
				});
			},
			sel_row_d: function(item, type) {
				// console.log(item, 'type=' + type);
				// console.log(this.parm);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				this.tid = item.id;
				this.tsysdate = item.sys_date;

				for (let i = 0; i < this.parm.length; i++) {
					switch (this.parm[i].key) {
						case 'item_name':
							this.parm[i].val = item.item_name;
							this.parm[i].sel_name = item.item_name;
							break;
						case 'item_qty':
							this.parm[i].val = item.item_qry;
							break;
						case 'item_price':
							this.parm[i].val = item.item_price;
							break;
						default:
							break;
					}
				}

				switch (type) {
					case 'edit': // 切换背景色
						let key = 'pop_md_';

						for (var i = 0; i < this.list_from_detail.length; i++) {
							if (this.list_from_detail[i].row_num == item.row_num) {
								document.getElementById(key + item.row_num).style.background = '#92a4f3';
							} else {
								if (this.list_from_detail[i].row_num % 2 == 0) {
									document.getElementById(key + this.list_from_detail[i].row_num).style.background =
										'#fff';
								} else {
									document.getElementById(key + this.list_from_detail[i].row_num).style.background =
										'#f5f5f5';
								}
							}
						}
						break;
						// case 'show': // 打开编辑页面
						// 	this.$refs.file_table.showpop();
						// 	break;
					default:
						break;
				}

				if (this.row_id > 0) {
					this.refresh_item();
				}

			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});
			
				});
			},






		}
	};
</script>


<style scoped>
	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}

	.content_edit_item button {
		margin-right: 8px;
	}

	.inline-row {
		line-height: 28px;
	}

	.inline-row-tab {
		display: inline-flex;
		align-items: flex-start;
	}

	.inline-tab {
		display: inline-flex;
		margin: 2px;
	}
	
	.mark_tab{
		display: inline-block;
		overflow-y: auto;
		max-height: 60vh;
	}

	.mark_tab tr td:nth-child(1) {
		display: none;
		min-width: 48px;
		width: 48px;
		max-width: 48px;
	}

	/*  .mark_tab tr td:nth-child(3) {
	  display: none;
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  	text-align: center;
  } */
</style>
